// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"25":"publication_analytics_plans_charts","703":"publication_analytics_members_chart"}[chunkId] + ".css";
};